import { ListaMaquinas } from "@/hooks/useMaquinas";
import { useFavoriteStore } from "@/_zustand/favorite";
import { resolverTiendasVisibles } from "@/lib/tiendasVisibles";

// Única capa que junta el store de favoritas con el padrón de máquinas
// activas para decidir qué tiendas mostrar; la lógica en sí vive en el módulo
// puro `src/lib/tiendasVisibles.js` (ver ahí el porqué). Mismo patrón que
// `useOneClickComercio` sobre `oneclickCards.js`.
//
// `ListaMaquinas` es el padrón SIN filtro de distancia
// (`/apiV2/maquina/listaMaquinas`, sólo filtra por estado activo), cacheado
// 10 minutos por React Query, así que consumirlo desde las dos páginas no
// agrega llamadas de red por navegación.
//
// `estadoCercanas` lo pasa el componente porque la query de
// `storeByDistance` vive allá (necesita lat/long y un refetch manual). Es
// obligatorio distinguir "cargando"/"error" de "no hay ninguna cerca": ver el
// comentario de resolverTiendasVisibles.
export const useTiendasVisibles = ({
  maquinasCercanas,
  tiendaId,
  mostrarFavoritas = false,
  estadoCercanas = "ok",
}) => {
  const { favorites } = useFavoriteStore();
  const { data: padronMaquinas } = ListaMaquinas();

  return resolverTiendasVisibles({
    favoritas: favorites,
    maquinasActivas: Array.isArray(padronMaquinas) ? padronMaquinas : [],
    maquinasCercanas,
    tiendaId,
    mostrarFavoritas,
    estadoCercanas,
  });
};

// Traduce el estado de una query de React Query al que espera el módulo puro.
export const estadoDeQuery = ({ isSuccess, isError }) =>
  isError ? "error" : isSuccess ? "ok" : "cargando";
